import { render, staticRenderFns } from "./DefaultSlave.vue?vue&type=template&id=27970f82&scoped=true&"
import script from "./DefaultSlave.vue?vue&type=script&lang=js&"
export * from "./DefaultSlave.vue?vue&type=script&lang=js&"
import style0 from "./DefaultSlave.vue?vue&type=style&index=0&id=27970f82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27970f82",
  null
  
)

export default component.exports